import styled from 'styled-components';

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const TotalLabel = styled.div``;
